<template>

  <div class="top-bar">

    <div class="stat-prompt-panel" v-if="tips.length > 0">
      <div class="mdl-card mdl-shadow--2dp">
        <div v-if="tipsExpanded">
          <div class="prompt mdl-card__supporting-text" v-for="(tip, tipId) in tips" v-bind:class="tip.name">
            <p>
              {{ tip.text }}
            </p>
            <button
              v-if="tip.filter"
              class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent"
              v-on:click="$emit('showTip', tip)">
              {{ i18n().tipApplyFilter }}
            </button>
          </div>
        </div>

        <div v-if="!tipsExpanded">
          <div class="mdl-card__supporting-text summary">
            {{ i18n().tipsSummary(tips.length) }}
          </div>
        </div>

        <div class="tipsHideButton">
          <button v-if="tipsExpanded" v-on:click="() => $emit('update:tipsExpanded', false)"
                  class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
            <i class="material-icons">expand_less</i></button>
          <button v-if="!tipsExpanded" v-on:click="() => $emit('update:tipsExpanded', true)"
                  class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent">
            <i class="material-icons">expand_more</i></button>
        </div>

      </div>

    </div>

    <div v-if="enableFilter" class="filterHolder">

      <TopFilterExpression :expression="filter" @update:expression="handleFilterUpdate"
                           :columns="calculatedColumnNames" :applied="!!appliedFilter"
                           @apply="$emit('applyFilter')" @update="$emit('updateFilter')"
                           @clear="$emit('clearFilter')"
                           :filterExpanded="filterExpanded"
                           @update:filterExpanded="(value) => $emit('update:filterExpanded', value)">
      </TopFilterExpression>

    </div>

  </div>

</template>

<script>

  import TopFilterExpression from "../query/TopFilterExpression"
  import config from "../../config"

  export default {
    name: "top-bar",
    props: {
      query: {
        type: Object
      },
      filter: {
        type: Object
      },
      appliedFilter: {
        type: Object
      },
      inputColumnNames: {
        type: Array
      },
      calculatedColumnNames: {
        type: Array
      },
      categories: {
        type: Array
      },
      enableFilter: {
        type: Boolean
      },
      tips: {
        type: Array
      },
      tipsExpanded: {
        type: Boolean
      },
      filterExpanded: {
        type: Boolean
      }
    },
    components: {
      TopFilterExpression
    },
    data() {
      return {
        queryExpand : true,
        filterExpand : true
      }
    },
    computed: {
      wordsColumnNames() {
        return this.inputColumnNames.filter(columnName => {
          if(config.logic.categoryColumns.indexOf(columnName) != -1) return false
          return true
        })
      }
    },
    methods: {
      i18n() { return i18n().tips },
      handleQueryUpdate(q) {
        this.$emit("update:query", q)
      },
      handleFilterUpdate(f) {
        this.$emit("update:filter", f)
      }
    }
  }

</script>

<style scoped>

  .summary {
    padding: 3px 20px;
  }

  .tipsHideButton {
    position: absolute;
    top: -16px;
    left: -16px;
    z-index: 2;
  }
  .tipsHideButton > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 0px;
    margin-right: 12px;
    flex-grow: 0;
  }

  .top-bar {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
  }

  .filterHolder {
    min-width: 750px;
    flex: 1;
    flex-shrink: 0;
    flex-grow: 1;
  }

  .stat-prompt-panel {
    min-width: 300px;
    padding: 8px;
    flex: 2;
    flex-grow: 2;
    flex-shrink: 0;
    position: relative;
    overflow: visible;
  }

  .stat-prompt-panel > .mdl-card {
    overflow: visible;
    width: 100%;
    box-sizing: border-box;
    min-height: 0;
    position: relative;
  }

  .stat-prompt-panel .mdl-card__title  > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 0px;
    margin-right: 12px;
    flex-grow: 0;
  }

  .prompt {
    display: flex;
    flex-direction: row;
    padding: 4px 12px;
    width: auto;
    align-items: center;
    border-top: 1px solid rgba(0,0,0, 0.2);
  }
  .prompt:nth-child(1) {
    border-top: none;
  }
  .prompt button {
    flex-shrink: 0;
    flex-grow: 0;
  }
  .prompt > p {
    flex-grow: 1;
    font-size: 1.23em;
    margin: 0;
    margin-right: 1em;
  }

</style>



// WEBPACK FOOTER //
// TopBar.vue?25fc9943